import { ContextType, useContext } from "react";

import { AuthContext } from "../../contexts/auth";

export default function useAuth(): ContextType<typeof AuthContext> {
  return useContext(AuthContext);
}
